import { render } from "./OppView.vue?vue&type=template&id=52deb8fa"
import script from "./OppView.vue?vue&type=script&lang=js"
export * from "./OppView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__